import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlogShellComponent } from '../../blog-shell/blog-shell.component';
import { TranslationSyncService } from '../../../../services/translation-sync.service';
import { BlogEntryBase } from '../../shared/blog-entry-base';

@Component({
  selector: 'app-design-decision',
  standalone: true,
  imports: [BlogShellComponent, CommonModule],
  templateUrl: './design-decision.component.html',
  styleUrls: ['./design-decision.component.css']
})
export class DesignDecisionComponent extends BlogEntryBase {
  constructor(sync: TranslationSyncService) {
    super(sync);
  }
}
